import { render, staticRenderFns } from "./Discharge.vue?vue&type=template&id=45f3de9a&"
import script from "./Discharge.vue?vue&type=script&lang=ts&"
export * from "./Discharge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports